export default __webpack_public_path__ + "locales/it/DataReassignmentDialog.json?hash=593098d69b3896bab2500da363cbd11e";